import { render, staticRenderFns } from "./InAppBrowser.vue?vue&type=template&id=238ce7c9&"
import script from "./InAppBrowser.vue?vue&type=script&lang=js&"
export * from "./InAppBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports